// extracted by mini-css-extract-plugin
export default {"wrapper":"id","form":"jd","smallprint":"kd","asterisk":"ld","success":"md","circle":"nd","button":"od"};